module.exports = __webpack_public_path__ + "img/SafetyHotline.18728d17.png";